import { createSlice } from "@reduxjs/toolkit";

const getSessionId = () => {

  const existing =localStorage.getItem("chat_session");

  if (existing) return existing;

  const newSession = crypto.randomUUID();

  localStorage.setItem("chat_session",newSession);

  return newSession;
};

const initialState = {
  sessionId: getSessionId(),
};

const chatSlice = createSlice({
  name: "chat",

  initialState,

  reducers: {

    resetSession: (state) => {
        const newSession =crypto.randomUUID();
        localStorage.setItem( "chat_session",newSession);
        state.sessionId = newSession;
     },
  },
});

export const { resetSession } =chatSlice.actions;

export default chatSlice.reducer;